import React from 'react';
import {NeuroMessage} from "@ignitesales/neuro-application";
import { useNeuroState } from "@ignitesales/neuro-application";
import ReactSVG from "react-svg";

const Footer = () => {
  const cssBEM = "footer";
  const { isFdicMember, isEhlMember } = useNeuroState();

  return <footer className={ cssBEM }>
    <div className="container">

      <div className={isFdicMember ? `${cssBEM}__copyright-with-fdic` : `${cssBEM}__copyright`}>
        <NeuroMessage id="footer.copyright" tagName="span" values={{
          year: (new Date()).getFullYear()
        }} />
      </div>

      <div className='icon-container'>
        { isEhlMember ? <ReactSVG src='/classpath/assets/images/ehl-logo.svg' className='ehl-icon' /> : null }
        { isFdicMember ? <ReactSVG src='/classpath/assets/images/fdic-logo.svg' className='fdic-icon' /> : null }
      </div>
    </div>
  </footer>
};

export default Footer;
